import config from '@/config/environment';

export const getAllowedIframeDomains = () => {
  const allowedIframeDomains = [
    config.MFE_IFRAME_CRM,
    config.MFE_IFRAME_COCOS,
    config.MFE_TS_AI_REPORTS_URL,
    config.MFE_IFRAME_HSM,
  ];

  return allowedIframeDomains;
};
